import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'getDisabledHours'
})
export class getDisabledHoursPipe implements PipeTransform {
  transform(value: number[]): () => number[] {
    return () => {
      const defaultDisabledHours = [0, 1, 2, 3, 4, 5, 6]
      if (!value) return defaultDisabledHours
      if (value && value?.length === 0) {
        return defaultDisabledHours
      }

      return [...defaultDisabledHours, ...value]
    }
  }
}
